import { AuthValue } from './types';

const getAuthValue = (isLoggedIn: boolean): AuthValue => (isLoggedIn ? 'logged-in' : 'public');

export default getAuthValue;
